import Vue from "vue";
import VueRouter from "vue-router";

import AdminPage from "@/Pages/AdminPage/index.vue";
import ListarUsuariosPage from "@/Pages/AdminPage/Usuarios/ListarUsuariosPage.vue";
import Notifiq from "@/Pages/Notifiq/index.vue";

import Caixas from "@/Pages/Caixas/index.vue";
import HomePage from "@/Pages/HomePage/index.vue";
import LoginPage from "@/Pages/LoginPage/index.vue";
import ResetPasswordPage from "@/Pages/LoginPage/ResetPasswordPage.vue";
import LogoutPage from "@/Pages/LogoutPage.vue";

import authService from "../Services/AuthService";
import acessoProfessor from "./acessoProfessor";
import acessoResponsavel from "./acessoResponsavel";
import agendas from "./agendas";
import alunos from "./alunos";
import aulas from "./aulas";
import autorizacoes from "./autorizacoes";
import avisos from "./avisos";
import circuitoNotas from "./circuito-notas";
import disciplinas from "./disciplinas";
import educacaoInclusiva from "./educacaoInclusiva";
import franquias from "./franquias";
import gestaoDeAulas from "./gestaoDeAulas";
import gestaoDeAulasAuxiliares from "./gestaoDeAulasAuxiliares";
import redirecionarSeForProfAuxiliar from "./guards/redirecionarSeForProfAuxiliar";
import redirecionarSeForProfessor from "./guards/redirecionarSeForProfessor";
import redirecionarSeForResponsavel from "./guards/redirecionarSeForResponsavel";
import inep from "./inep";
import matriculas from "./matriculas";
import mensalidades from "./mensalidades";
import notas from "./notas";
import notifiq from "./notifiq";
import planos from "./planos";
import professores from "./professores";
import relatorios from "./relatorios";
import series from "./series";
import turmas from "./turmas";
import usuarios from "./usuarios";
import gestaoDeAulasAEE from "./gestaoDeAulasAEE";
import acompanhamentos from "./acompanhamentos";
import NaoAutorizado from "../Pages/NaoAutorizado.vue";
import historico from "./historico";
import bolsaFamilia from "./bolsa-familia";
import fundeb from "./fundeb";
import prematriculas from "./prematriculas";

Vue.use(VueRouter);

const routes = [
  {
    path: "/notifiq/index",
    name: "notifiq.index",
    component: Notifiq,
    // Sem o guardião de rota, para permitir o acesso sem autenticação
  },
  {
    path: "/",
    redirect: { name: "login" },
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    beforeEnter(target, from, next) {
      if (authService.isLoggedIn()) {
        return next({ name: "home" });
      }
      return next();
    },
  },
  {
    path: "/home",
    name: "home",
    component: HomePage,
    beforeEnter: async (to, from, next) => {
      await redirecionarSeForResponsavel(to, from, next);
      await redirecionarSeForProfessor(to, from, next);
      await redirecionarSeForProfAuxiliar(to, from, next);
      return next();
    },
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: ResetPasswordPage,
    beforeEnter(target, from, next) {
      if (authService.isLoggedIn()) {
        return next({ name: "home" });
      }
      return next();
    },
  },
  {
    path: "/caixas",
    name: "caixas",
    component: Caixas,
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminPage,
    beforeEnter(to, from, next) {
      return next({ name: "home" });
    },
  },
  {
    path: "/admin/usuarios/listar",
    name: "admin.usuarios.listar",
    component: ListarUsuariosPage,
    beforeEnter(to, from, next) {
      return next({ name: "home" });
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: LogoutPage,
  },
  {
    path: "/nao-autorizado",
    name: "NaoAutorizado",
    component: NaoAutorizado,
  },
  ...mensalidades,
  ...franquias,
  ...turmas,
  ...series,
  ...disciplinas,
  ...alunos,
  ...professores,
  ...matriculas,
  ...usuarios,
  ...inep,
  ...gestaoDeAulas,
  ...gestaoDeAulasAuxiliares,
  ...aulas,
  ...acessoProfessor,
  ...acessoResponsavel,
  ...notas,
  ...relatorios,
  ...educacaoInclusiva,
  ...avisos,
  ...agendas,
  ...notifiq,
  ...planos,
  ...circuitoNotas,
  ...autorizacoes,
  ...gestaoDeAulasAEE,
  ...acompanhamentos,
  ...historico,
  ...bolsaFamilia,
  ...fundeb,
  ...prematriculas,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const publicRoutes = ["login", "resetPassword", "notifiq.index", "prematriculas.create"];
  if (!publicRoutes.includes(to.name) && !authService.isLoggedIn()) {
    next({
      name: "login",
      query: {
        redirect: to.fullPath,
        name: to.name,
      },
    });
  } else {
    next();
  }
});

export default router;
